import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
      <img
        src="/lovable-uploads/21200f85-e251-4faf-8648-80e06df97b5e.png"
        alt="SkuHub Logo"
        className="w-8 h-8"
      />
      <span className="text-xl font-bold text-white">SkuHub</span>
    </Link>
  );
};